import AppleSection from "@/components/AppleSection";
import { getAllClassifiedTypes } from "@/utils/businessClassifier";
import { blogPosts } from "@/data/blogPosts";
import { Link } from "react-router-dom";
import Footer from "@/components/Footer";

export default function Negocios() {
  // Obtener tipos de negocio usando el nuevo sistema de clasificación cerrada
  const { businessEntries } = getAllClassifiedTypes();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <AppleSection background="black" padding="large">
        <div className="text-center space-y-8">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-light text-white dark:text-black">
            ¿Qué tipo de negocio tienes?
          </h1>
          <p className="text-2xl md:text-3xl font-light text-gray-400 dark:text-gray-600 max-w-4xl mx-auto">
            Encuentra las soluciones de IA diseñadas específicamente para tu sector.
          </p>
        </div>
      </AppleSection>

      {/* Negocios Section */}
      <AppleSection background="white" padding="large">
        <div className="max-w-6xl mx-auto space-y-24">
          {/* Tipos de Negocio REALES */}
          <div id="tipos-negocio" className="space-y-12">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-center text-foreground">
              Tipos de Negocio
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              {businessEntries.map(([businessType, articleIds]) => (
                <Link
                  key={businessType}
                  to={`/negocios/${businessType.toLowerCase()}`}
                  id={businessType.toLowerCase().replace(/\s+/g, '-')}
                  className="group space-y-6 p-8 rounded-2xl hover:bg-secondary transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 border border-border/30"
                >
                  <h3 className="text-3xl font-semibold text-foreground group-hover:text-primary transition-colors">
                    {businessType}
                    <span className="ml-3 text-2xl group-hover:translate-x-2 inline-block transition-transform">→</span>
                  </h3>
                  <p className="text-lg text-muted-foreground">
                    {articleIds.length} soluciones disponibles
                  </p>
                  <div className="space-y-2">
                    {articleIds.slice(0, 3).map(articleId => {
                      const article = blogPosts.find(p => p.id === articleId);
                      return article ? (
                        <div
                          key={articleId}
                          className="text-base text-muted-foreground line-clamp-1"
                        >
                          <span className="mr-2">{article.emoji}</span>
                          {article.title}
                        </div>
                      ) : null;
                    })}
                    {articleIds.length > 3 && (
                      <p className="text-sm text-muted-foreground italic">
                        +{articleIds.length - 3} más...
                      </p>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </AppleSection>

      {/* CTA Section */}
      <AppleSection background="black" padding="normal">
        <div className="text-center space-y-8">
          <p className="text-2xl md:text-3xl font-light text-white dark:text-black">
            ¿No encuentras tu sector?
          </p>
          <p className="text-xl text-gray-400 dark:text-gray-600">
            Contacta con nosotros y te ayudamos a encontrar la solución perfecta.
          </p>
          <Link
            to="/contacto"
            className="inline-block px-8 py-4 bg-white dark:bg-black text-black dark:text-white text-lg font-semibold rounded-full hover:bg-gray-100 dark:hover:bg-gray-900 transition-colors"
          >
            Hablar con un experto
          </Link>
        </div>
      </AppleSection>

      <Footer />
    </div>
  );
}
